import { Navigate } from "react-router-dom";
import type { RouteRecord } from "vite-react-ssg";
import { ViteReactSSG } from "vite-react-ssg";

import { About } from "./pages/About.js";
import { ContactUs } from "./pages/ContactUs.js";
import { CoreCommittee } from "./pages/CoreCommittee.js";
import { DownloadApp } from "./pages/DownloadApp.js";
import { Home } from "./pages/Home.js";
import { JivaSevaApp } from "./pages/JivaSevaApp.js";
import { PrivacyPolicy } from "./pages/PrivacyPolicy.js";
import { RaiseConcern } from "./pages/RaiseConcern.js";
import { Spirit } from "./pages/Spirit.js";
import { SpiritQuotations } from "./pages/SpiritQuotations.js";
import { TermsOfService } from "./pages/TermsOfService.js";
import "./landing.css";

// Public marketing website — no authentication. The content pages are
// prerendered (see includedRoutes); the legacy aliases and catch-all are
// client-side redirects served via the SPA fallback.
export const routes: RouteRecord[] = [
  { path: "/", element: <Home /> },
  { path: "/about", element: <About /> },
  { path: "/spirit", element: <Spirit /> },
  { path: "/spirit/quotations", element: <SpiritQuotations /> },
  { path: "/app", element: <JivaSevaApp /> },
  { path: "/app/core-committee", element: <CoreCommittee /> },
  { path: "/download-app", element: <DownloadApp /> },
  { path: "/raise-a-concern", element: <RaiseConcern /> },
  { path: "/contact", element: <ContactUs /> },
  { path: "/privacy-policy", element: <PrivacyPolicy /> },
  { path: "/terms-of-service", element: <TermsOfService /> },

  // legacy aliases + catch-all (not prerendered)
  { path: "/mission", element: <Navigate to="/about#mission" replace /> },
  { path: "/get-involved", element: <Navigate to="/about#get-involved" replace /> },
  { path: "/how-it-works", element: <Navigate to="/app" replace /> },
  { path: "/sevawallet", element: <Navigate to="/app" replace /> },
  { path: "/digidhana", element: <Navigate to="/app" replace /> },
  { path: "/perform-seva", element: <Navigate to="/app" replace /> },
  { path: "/my-wallet", element: <Navigate to="/app" replace /> },
  { path: "*", element: <Navigate to="/" replace /> }
];

// Only prerender the real content pages; redirects/catch-all stay client-side.
const PRERENDER = new Set([
  "/",
  "/about",
  "/spirit",
  "/spirit/quotations",
  "/app",
  "/app/core-committee",
  "/download-app",
  "/raise-a-concern",
  "/contact",
  "/privacy-policy",
  "/terms-of-service"
]);

export const includedRoutes = (paths: string[]) =>
  paths.filter((path) => PRERENDER.has(path));

export const createRoot = ViteReactSSG({ routes });
